module.exports = "/_next/static/images/dfaf4e6815b4b6f3c8ebfa941dd74876-receive.svg";